module.exports = __webpack_public_path__ + "img/logo_kn.0dc92541.png";